import { makeStyles } from "@material-ui/core";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  Button,
  Grid,
  TextField,
  TextareaAutosize,
  Tooltip,
  Typography,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/material/styles";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import * as XLSX from "xlsx";
import xlslogo from "../../../src/assets/USA_Images/dashboard_icons/xls.svg";
import CustomDateTimePicker from "../../components/CustomInputs/CustomDateTimePicker";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import BulkInvitationDialog from "../../components/DialogBoxComponent/BulkInvitationDialog";
import ProfileContext from "../../components/ProfileContext";
import Toast from "../../components/ToastContainer/CustomToast";
import httpCommon from "../../config/http-common";
import { createMultiplePreRegistration } from "../../slices/Invitations/InvitationsSlice";
import { getAllSites } from "../../slices/Site/SiteSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import EditIcon from "../Person/EditIcon";
import BulkPreRegistrationEdit from "./BulkPreRegistrationEdit";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const useStyles = makeStyles((theme) => ({
  dialogbox: {
    "& .MuiDialogActions-root": {
      marginLeft: "700px !important",
    },
    "& .MuiDialog-paper": {
      minWidth: "1000px",
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
    ".& .css-f3jnds-MuiDataGrid-columnHeaders": {
      backgroundColor: "#F3F9FB",
    },
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "35px",
  },
  headerItem: {
    backgroundColor: "#226BAB",
    color: "white",
  },
  datagrid: {
    "&.MuiDataGrid-root": {
      borderColor: "#949596",
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: (props) => (props.darkMode ? "#0B2E4D" : "#2286AB"),
      color: "#fff",
      borderBottom: (props) =>
        props.darkMode ? "2px solid #0B2E4D" : "2px solid #2286AB",
    },
    "& .MuiDataGrid-overlay": {
      display: "none",
    },
    "& .MuiDataGrid-main": {
      borderRadius: "0px !important",
      borderStyle: "hidden !important",
      "& > .MuiDataGrid-columnHeaders": {
        borderTop: "none",
        borderRadius: "0px",
      },
    },
    "& .MuiDataGrid-cell": {
      borderBottom: `1px solid ${(props) =>
        props.darkMode ? "#1265ab21" : "#80808026"} !important`,
      color: (props) =>
        props.darkMode ? "white !important" : "#000 !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: (props) =>
        props.darkMode
          ? "rgba(255, 255, 255, 0.12) !important"
          : "rgba(0, 0, 0, 0.07) !important",
      cursor: "pointer",
    },
    "& .MuiDataGrid-footerContainer": {
      minHeight: "26px",
      borderTop: (props) => (props.darkMode ? "none" : ""),
    },
    "& .MuiDataGrid-iconSeparator": {
      color: (props) => (props.darkMode ? "#0E2A41CC" : "#2286AB"),
    },
    "& .MuiToolbar-root": {
      marginRight: "20px !important",
    },
    "& .MuiTablePagination-root": {
      color: (props) => (props.darkMode ? "#fff" : ""),
    },

    "& .MuiSvgIcon-root": {
      color: "#949596",
    },
  },
  errorListStyles: {
    color: "red",
  },
  successListStyles: {
    color: "green",
  },
}));

function BulkPerRegistration(props) {
  const { darkMode } = useContext(ThemeContext);
  const classes = useStyles({ darkMode });
  const [open, setOpen] = React.useState(props.open);
  const [siteData, setSiteData] = useState([]);
  const { t } = useTranslation();
  const { handleClose } = props;
  const dispatch = useDispatch();
  const [errorList, setErrorList] = useState([]);
  const [successList, setSuccessList] = useState([]);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [excelFile, setExcelFile] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editRowData, setEditRowData] = useState(null);
  const [importError, setImportError] = useState(false);
  const { setCurrentTotalVisitCount } = useContext(ProfileContext);
  const [key, setKey] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [siteTimeEnable, setSiteTimeEnable] = useState(true);
  const [siteCurrentDateTime, setSiteCurrentDateTime] = useState(null);
  const [datatableValue, setDatatableValue] = useState({
    siteName: "",
    siteTimeZone: "",
  });
  const [success, setSuccess] = useState(false);
  const [changeDate, setDateChange] = useState(true);

  var today = new Date();

  var minutes =
    props.perRegistrationIntervalTime === ""
      ? 30
      : Number(props.perRegistrationIntervalTime);
  const [perRegistrationIntervalTime, setInvitationIntervalTime] = useState(
    minutes,
  );

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };

  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T" +
    (today.getHours() < 10 ? "0" + today.getHours() : today.getHours()) +
    ":" +
    (today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes());

  const [payload, setPayload] = useState({
    firstName: "",
    lastName: "",
    siteId: "",
    siteTimeZone: "",
    scheduledStartDate: CommonUtil.formatLocalDateTime(startDate),
    scheduledEndDate: CommonUtil.formatLocalDateTime(
      moment(startDate).add(perRegistrationIntervalTime, "minutes"),
    ),
    visitMode: "PRE_REGISTRATION",
    profilePhoto: "str.jpg",
    remarks: "",
  });

  const [error, setError] = useState({
    firstName: false,
    siteId: false,
  });

  useEffect(() => {
    if (file === null) {
      setKey((prevKey) => prevKey + 1);
    }
  }, [file]);

  useEffect(() => {
    loadData(props.open);
  }, []);

  useEffect(() => {
    console.log("Success List:", successList);
  }, [successList]);

  useEffect(() => {
    console.log("Error List:", errorList);
  }, [errorList]);

  const loadData = () => {
    loadSites();
  };

  const loadSites = () => {
    const query = {
      page: 1,
      rowsPerPage: 10000,
      name: "",
    };
    dispatch(getAllSites(query))
      .unwrap()
      .then((data) => {
        if (data.code === "LMSI0000") {
          setSiteData(data.data.site);
        } else {
          setSiteData([]);
        }
      });
  };

  // Only one site available: select it automatically and load its schedule time
  useEffect(() => {
    if (siteData.length === 1) {
      const site = siteData[0];
      setPayload((prev) => ({ ...prev, siteId: site }));
      setDatatableValue((prev) => ({
        ...prev,
        siteName: site,
        siteTimeZone: site.timeZone ? site.timeZone : "",
      }));
      getSiteCurrentDateTime(site.id);
    }
  }, [siteData]);

  const handleDownloadTemplate = () => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Define the header row
    const header = ["First Name (mandatory)", "Last Name"];

    // Add a worksheet to the workbook
    const ws = XLSX.utils.aoa_to_sheet([header]);

    const columnWidths = [30, 30]; // Adjust the values as needed (in Excel's "characters" units)
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let columnIndex = range.s.c; columnIndex <= range.e.c; columnIndex++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: columnIndex });
      ws[cellAddress].w = header[columnIndex];
      ws["!cols"] = ws["!cols"] || [];
      ws["!cols"][columnIndex] = { wch: columnWidths[columnIndex] };
    }

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate the Excel file
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

    // Convert the Excel file to a Blob
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });

    // Create a download link and simulate a click
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "PreRegistration.xlsx";
    link.click();

    // Clean up the URL object
    URL.revokeObjectURL(link.href);
  };

  // Utility function to convert a string to an ArrayBuffer
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  const columns = [
    {
      field: "firstName",
      headerName: t("COMMON020"),
      flex: 1,
      minWidth: 190,
      width: 150,
    },
    {
      field: "lastName",
      headerName: t("COMMON021"),
      flex: 1,
      minWidth: 190,
      width: 150,
    },
    {
      field: "siteName",
      headerName: t("VISACCDEV005"),
      flex: 1,
      minWidth: 190,
      width: 150,
    },
    {
      field: "scheduledStartDate",
      headerName: t("START_DATE"),
      flex: 1,
      minWidth: 190,
      width: 150,
    },
    {
      field: "scheduledEndDate",
      headerName: t("END_DATE"),
      flex: 1,
      minWidth: 190,
      width: 150,
    },
    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 190,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          disabled={getStatus(params)}
          onClick={() => handleOpenEditPerson(params.row)}
        />,
      ],
    },
  ];

  const errorColumns = [
    {
      field: "firstName",
      headerName: t("COMMON020"),
      flex: 1,
      minWidth: 190,
      width: 150,
      valueGetter: (params) => params.row?.data?.firstName,
    },

    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 190,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          disabled={getStatus(params)}
          onClick={() => handleOpenEditPerson(params.row)}
        />,
      ],
    },
  ];

  const getSiteCurrentDateTime = (siteId) => {
    httpCommon
      .securedAxios()
      .get(`/web/visit/site/${siteId}/currectDateTime`)
      .then((response) => {
        if (
          response?.data?.code === "CVAI0000" &&
          response.data.data?.siteCurrentTime
        ) {
          const startDate = new Date(response.data.data.siteCurrentTime);
          setPayload((prev) => ({
            ...prev,
            scheduledStartDate: CommonUtil.formatLocalDateTime(startDate),
            scheduledEndDate: CommonUtil.formatLocalDateTime(
              moment(startDate).add(perRegistrationIntervalTime, "minutes"),
            ),
          }));
          setSiteCurrentDateTime(startDate);
          setSiteTimeEnable(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getStatus = (params) => {
    if (params.row.status === "success") {
      return true;
    }
    return false;
  };

  const handleOpenEditPerson = (params) => {
    if (importError) {
      setEditRowData(params.data);
    } else {
      setEditRowData(params);
    }
    setOpenEditDialog(!openEditDialog);
  };

  const handleFileUpload = (event) => {
    const uploadedFile = event.target.files[0];
    setFile(uploadedFile);
    setFileName(uploadedFile.name);
    setExcelFile(uploadedFile);
  };

  const handleImport = (event) => {
    event.preventDefault();
    if (!success) {
      Toast(t("PERSONINFO19"), "error");
      return;
    }
    if (datatableValue.siteName == "") {
      Toast(t("PERSONINFO20"), "error");
      return;
    }
    if (file == null) {
      Toast(t("PERSONINFO21"), "error");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("file", file);

      axios
        .post(
          "/web/bulk/import/pre_registration" + "?fileName=" + fileName,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem("VISJwtToken"),
            },
          },
        )
        .then((res) => {
          if (res.data.code == "CVAE1002") {
            const newSuccessList = res.data.data.successList.map((item) => {
              return {
                ...item,
                siteName: datatableValue.siteName.name,
                visitMode: "PRE_REGISTRATION",
                siteId: datatableValue.siteName.id,
                siteTimeZone: datatableValue.siteTimeZone,
                scheduledStartDate: payload.scheduledStartDate,
                scheduledEndDate: payload.scheduledEndDate,
                remarks: payload.remarks,
              };
            });
            const newErrorList = res.data.data.errorList.map((item) => {
              return {
                ...item,
                siteName: datatableValue.siteName.name,
                visitMode: "PRE_REGISTRATION",
                siteId: datatableValue.siteName.id,
                siteTimeZone: datatableValue.siteTimeZone,
                scheduledStartDate: payload.scheduledStartDate,
                scheduledEndDate: payload.scheduledEndDate,
                remarks: payload.remarks,
              };
            });
            setSuccessList(newSuccessList);
            setErrorList(newErrorList);
            setFile(null);
            Toast(t("EMP1"), "success");
          } else {
            Toast(res.data.message, "error");
          }
        });

      //  alert('File uploaded successfully.');
    } catch (error) {
      alert("Failed to upload file: " + error.message);
    }
  };

  const handleSave = (updatedRowData) => {
    const updatedErrorList = errorList.filter(
      (row) => (row.data?.id ? row.data?.id : row?.id) !== updatedRowData.id,
    );
    setErrorList(updatedErrorList);
    const updatedSuccessList = {
      ...updatedRowData,
      scheduledStartDate: payload.scheduledStartDate,
      scheduledEndDate: payload.scheduledEndDate,
      status: "success",
    };

    setSuccessList((prevList) => [...prevList, updatedSuccessList]);
    console.log(successList);
    console.log(errorList);
  };

  const handleMoreDetails = () => {
    if (datatableValue.siteName === "") {
      Toast(t("SITE2"), "error");
      return;
    }
    if (
      new Date(payload.scheduledEndDate) < new Date(payload.scheduledStartDate)
    ) {
      Toast(t("INVITATIONFORM003"), "error");
      return;
    }
    setSuccess(true);
    Toast(t("PERSONINFO26"), "success");
  };

  const emptyParams = [];

  const seenSuccessNames = new Set(
    successList
      .filter((item) => !CommonUtil.isEmptyString(item.firstName))
      .map((item) => item.firstName.trim().toLowerCase()),
  );
  const seenErrorNames = new Set();

  const rows = errorList.map((error, index) => {
    const row = {
      id: index + 1,
      rowNumber: index + 1,
      firstName: error.firstName,
    };

    let reason = error.message;
    if (CommonUtil.isEmptyString(reason)) {
      if (CommonUtil.isEmptyString(error.firstName)) {
        reason = "First Name is mandatory";
      } else {
        const normalizedName = error.firstName.trim().toLowerCase();
        reason =
          seenSuccessNames.has(normalizedName) ||
          seenErrorNames.has(normalizedName)
            ? "Duplicate Visitor Name"
            : "Invalid Visitor Name";
      }
    }
    if (!CommonUtil.isEmptyString(error.firstName)) {
      seenErrorNames.add(error.firstName.trim().toLowerCase());
    }

    if (reason) {
      emptyParams.push(`Row ${index + 1}: ${reason}`);
    }
    return row;
  });

  const emptyParamsText = emptyParams.join("\n");

  const handleSubmit = () => {
    if (emptyParamsText.length > 0) {
      Toast(t("PERSONINFO7"), "error");
      return;
    }
    if (excelFile == null) {
      Toast(t("PERSONINFO6"), "error");
      return;
    }
    dispatch(createMultiplePreRegistration(successList))
      .unwrap()
      .then((res) => {
        if (res.code === "CVAE1006") {
          setImportError(true);
          setSuccessList([]);
          setErrorList(res.data.errorData);
          setCurrentTotalVisitCount(res.data.currentVisitCount);
          Toast(res.message, "error");
          return;
        }
        if (res.code === "MSGS4000") {
          Toast(t("PERSONINFO27"), "success");
          setCurrentTotalVisitCount(res.data.currentVisitCount);
          handleClose();
          return;
        }
        if (res.code === "CVAE1004") {
          Toast(res.message, "error");
          return;
        } else {
          Toast(res.message, "error");
          return;
        }
      });
  };

  const handleChange = (event) => {
    const name = event.target.name;
    let value = event.target.value;
    setPayload({
      ...payload,
      [name]: value,
    });
    setDatatableValue({
      ...datatableValue,
      [name]: value,
    });
    setError({
      [name]: false,
    });
  };

  const dateFormat = props.date;

  const formatDate = (date, dateFormat) => {
    const formattedDate = moment(CommonUtil.formatLocalDateTime(date)).format(
      dateFormat === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : dateFormat === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : dateFormat === "yyyy-MM-dd HH:mm"
        ? "YYYY-MM-DD HH:mm"
        : "",
    );
    return formattedDate;
  };

  const formattedRows = errorList.concat(successList).map((row) => ({
    ...row,
    scheduledStartDate: formatDate(row.scheduledStartDate, dateFormat),
    scheduledEndDate: formatDate(row.scheduledEndDate, dateFormat),
  }));

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  useEffect(() => {
    const validErrorList = Array.isArray(errorList) ? errorList : [];
    const validSuccessList = Array.isArray(successList) ? successList : [];
    const list = importError
      ? validErrorList.length
      : validErrorList.length + validSuccessList.length;
    const records = list;
    const pages = Math.ceil(records / pageSize) || 1;
    setTotalRecords(records);
    setTotalPages(pages);
    setPage((current) => Math.min(current, pages));
  }, [errorList, successList, pageSize, importError]);

  const handleTablePageChange = (newPage, size) => {
    setPageSize(Number(size) || pageSize);
    setPage(newPage);
  };

  const pagedRows = (importError ? errorList : formattedRows).slice(
    (page - 1) * pageSize,
    page * pageSize,
  );

  return (
    <>
      <BulkInvitationDialog
        className={classes.dialogbox}
        Header={
          <span style={{ color: darkMode ? "#fff" : "black" }}>
            {t("VISACCLEVEL003")}
          </span>
        }
        acceptText={t("VISACCLEVEL004")}
        cancelText={t("COMMON008")}
        onSubmit={handleSubmit}
        open={open}
        onClose={handleClose}
        cancel={handleClose}
        darkMode={darkMode}
      >
        <Grid
          container
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <Grid
            container
            padding={2}
            spacing={2}
            style={{
              paddingTop: "0px",
              paddingBottom: "0px",
            }}
          >
            <Grid item sm={12} xs={12} md={3} lg={3}>
              <Typography>
                <Box
                  sx={{
                    fontWeight: "bold",
                    m: 1,
                    width: "max-content",
                    color: darkMode ? "#fff" : "black",
                  }}
                >
                  {t("PERSONINFO8")}{" "}
                </Box>
              </Typography>

              <Box
                sx={{
                  height: "370px",
                  border: "2px dashed #949596",
                  borderRadius: "9px",
                  background: darkMode
                    ? " #0E2A41 0% 0% no-repeat padding-box"
                    : " #F3F9FB 0% 0% no-repeat padding-box",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    flex: 1,
                  }}
                >
                  <div
                    style={{
                      paddingTop: "10px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <img src={xlslogo}></img>
                  </div>
                  <Typography
                    style={{
                      color: darkMode ? "#fff" : "black",
                      paddingTop: "10px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {t("buttonSampleTemplate")}
                  </Typography>

                  <Typography
                    variant="h7"
                    sx={{
                      ml: "38px",
                      mt: "20px",
                      color: darkMode ? "#fff" : "black",
                    }}
                  >
                    {t("DOWNLOAD_TEMPLATE")} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    &nbsp; {t("FORMAT_FILL_DETAILS")}
                  </Typography>
                </Box>

                <Box
                  style={{
                    paddingBottom: "10px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    sx={{
                      backgroundColor: "#F2824C",
                      color: "#FFFFFF",
                      borderRadius: "40px !important",
                      width: "150px",
                      height: "42px",
                    }}
                    onClick={handleDownloadTemplate}
                  >
                    {t("EXPORTSUCCESS008")}
                  </Button>
                </Box>
              </Box>
            </Grid>

            <Grid item sm={12} xs={12} md={6} lg={6}>
              <Typography>
                <Box
                  sx={{
                    fontWeight: "bold",
                    m: 1,
                    width: "max-content",
                    color: darkMode ? "#fff" : "black",
                  }}
                >
                  {t("PERSONINFO13")}
                </Box>
              </Typography>

              <Box
                sx={{
                  flex: 1,
                  height: "370px",
                  border: "2px dashed #949596",
                  borderRadius: "9px",
                  background: darkMode
                    ? " #0E2A41 0% 0% no-repeat padding-box"
                    : " #F3F9FB 0% 0% no-repeat padding-box",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    flex: 1,
                  }}
                >
                  <Grid container padding={2} spacing={2}>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <Autocomplete
                        popupIcon={<ExpandMoreIcon />}
                        style={{
                          width: "100%",
                        }}
                        noOptionsText={"No Options found"}
                        name="siteId"
                        value={datatableValue.siteName || null}
                        disabled={siteData.length === 1}
                        options={
                          CommonUtil.isEmptyArray(siteData) ? [] : siteData
                        }
                        getOptionLabel={(option) =>
                          option.name ? option.name : ""
                        }
                        onChange={(event, newValue) => {
                          if (!CommonUtil.isEmpty(newValue)) {
                            setPayload({ ...payload, siteId: newValue });
                            setDatatableValue({
                              ...datatableValue,
                              siteName: newValue,
                              siteTimeZone: newValue.timeZone
                                ? newValue.timeZone
                                : "",
                            });
                            getSiteCurrentDateTime(newValue.id);
                          } else {
                            setDatatableValue({
                              ...datatableValue,
                              siteName: "",
                              siteTimeZone: "",
                            });

                            setSiteTimeEnable(true);
                            setSiteCurrentDateTime(null);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required={true}
                            name="siteId"
                            variant="outlined"
                            fullWidth
                            label={t("SITE013")}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <CustomDateTimePicker
                        onChange={(scheduledStartDate) =>
                          setPayload({
                            ...payload,
                            scheduledStartDate: CommonUtil.formatLocalDateTime(
                              scheduledStartDate,
                            ),
                            scheduledEndDate: CommonUtil.formatLocalDateTime(
                              moment(scheduledStartDate).add(
                                perRegistrationIntervalTime,
                                "minutes",
                              ),
                            ),
                          })
                        }
                        minDateTime={siteCurrentDateTime}
                        value={payload.scheduledStartDate}
                        label={t("INVITESTARTDATEERROR1")}
                        changeDate={changeDate}
                        date={props.date}
                        disabled={siteTimeEnable}
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <CustomDateTimePicker
                        onChange={(scheduledEndDate) =>
                          setPayload({
                            ...payload,
                            scheduledEndDate: CommonUtil.formatLocalDateTime(
                              scheduledEndDate,
                            ),
                          })
                        }
                        value={payload.scheduledEndDate}
                        minDateTime={
                          payload.scheduledStartDate
                            ? new Date(payload.scheduledStartDate)
                            : undefined
                        }
                        label={t("INVITESTARTDATEERROR2")}
                        changeDate={changeDate}
                        date={props.date}
                        disabled={siteTimeEnable}
                      />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <CustomTextfield
                        label={t("COMMON016")}
                        name="remarks"
                        value={payload.remarks}
                        handleChange={(e) => handleChange(e)}
                        validation="restrictLength"
                        autoComplete="off"
                        inputProps={{ maxLength: 100 }}
                        InputProps={{
                          style: {
                            color: darkMode ? "#fff" : "black",
                          },
                        }}
                      />{" "}
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  container
                  justifyContent="center"
                  style={{
                    paddingBottom: "10px",
                  }}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      sx={{
                        bgcolor: "#F2824C",
                        color: "white",
                        borderRadius: "40px !important",
                        width: "150px",
                        height: "42px",
                      }}
                      onClick={handleMoreDetails}
                    >
                      {t("COMMON007")}
                    </Button>
                  </Grid>
                </Box>
              </Box>
            </Grid>
            <Grid item sm={12} xs={12} md={3} lg={3}>
              <Typography>
                <Box
                  sx={{
                    fontWeight: "bold",
                    m: 1,
                    width: "max-content",
                    color: darkMode ? "#fff" : "black",
                  }}
                >
                  {t("PERSONINFO14")}
                </Box>
              </Typography>

              <Box
                sx={{
                  height: "370px",
                  border: "2px dashed #949596",
                  borderRadius: "9px",
                  background: darkMode
                    ? " #0E2A41 0% 0% no-repeat padding-box"
                    : " #F3F9FB 0% 0% no-repeat padding-box",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    flex: 1,
                    paddingTop: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <img src={xlslogo}></img>
                  </div>

                  <Typography
                    style={{
                      color: darkMode ? "#fff" : "black",
                      display: "flex",
                      justifyContent: "center",
                      paddingTop: "10px",
                    }}
                  >
                    {t("PERSONINFO15")}
                  </Typography>

                  <Typography
                    variant="h7"
                    sx={{
                      paddingTop: "10px",
                      color: darkMode ? "#fff" : "black",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {t("PERSONINFO16")}
                  </Typography>

                  <Grid
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      paddingTop: "10px",
                    }}
                  >
                    <Button
                      component="label"
                      role={undefined}
                      tabIndex={-1}
                      startIcon={<CloudUploadIcon />}
                      sx={{
                        backgroundColor: "cadetblue",
                        borderRadius: "40px !important",
                        width: "150px",
                        height: "40px",
                        color: "white",
                      }}
                    >
                      Upload file
                      <VisuallyHiddenInput
                        type="file"
                        onChange={handleFileUpload}
                      />
                    </Button>
                  </Grid>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Tooltip title={fileName}>
                      <Typography
                        style={{
                          color: darkMode ? "#fff" : "black",
                          fontWeight: "bold",
                          paddingTop: "10px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          width: "42%",
                        }}
                      >
                        {fileName}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Box>

                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    paddingBottom: "10px",
                  }}
                >
                  <Button
                    sx={{
                      backgroundColor: "#F2824C",
                      color: "#FFFFFF",
                      borderRadius: "40px !important",
                      width: "150px",
                      height: "42px",
                      mt: "100px",
                    }}
                    onClick={handleImport}
                  >
                    {t("VISACCLEVEL003")}
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Box>
            <Typography variant="h4">
              <Box
                sx={{
                  fontWeight: "bold",
                  ml: "15px",
                  color: "black",
                  mt: "15px",
                  color: darkMode ? "#fff" : "black",
                }}
              >
                {t("PERSONINFO17")}
              </Box>
            </Typography>
            <Typography>
              <Box
                sx={{
                  ml: "15px",
                  color: "black",
                  opacity: 0.7,
                  mt: "5px",
                  color: darkMode ? "#fff" : "black",
                }}
              >
                {t("PERSONINFO18")}
              </Box>
            </Typography>

            <Box>
              <TextareaAutosize
                className="textareaStyle"
                minRows={3}
                maxlength="300"
                rows={emptyParams.length + 1}
                value={emptyParamsText}
                readOnly
                style={{
                  color: "red",
                  marginLeft: "15px",
                  borderColor: darkMode ? "#576A7A" : "#ccc",
                  background: darkMode
                    ? " #0E2A41 0% 0% no-repeat padding-box"
                    : " #F3F9FB 0% 0% no-repeat padding-box",
                  width: "965px",
                }}
              />
            </Box>
          </Box>
          <div style={{ height: "250px", width: "100%" }}>
            {importError ? (
              <DataTableLatest
                columns={errorColumns}
                rows={pagedRows}
                getRowClassName={(params) => {
                  if (params.row.status === "error") {
                    return classes.errorListStyles;
                  } else {
                    return classes.successListStyles;
                  }
                }}
                dashboardPanel={true}
                page={page}
                bulkLeft={true}
                bulkRight={true}
                count={totalRecords}
                pageCount={totalPages}
                pageSize={pageSize}
                handleChange={handleTablePageChange}
              />
            ) : (
              <DataTableLatest
                columns={columns}
                rows={pagedRows}
                getRowClassName={(params) => {
                  if (params.row.status === "error") {
                    return classes.errorListStyles;
                  } else {
                    return classes.successListStyles;
                  }
                }}
                dashboardPanel={true}
                bulkLeft={true}
                bulkRight={true}
                page={page}
                count={totalRecords}
                pageCount={totalPages}
                pageSize={pageSize}
                handleChange={handleTablePageChange}
              />
            )}
          </div>
        </Grid>
      </BulkInvitationDialog>
      {openEditDialog && (
        <BulkPreRegistrationEdit
          open={openEditDialog}
          onClose={() => {
            setOpenEditDialog(false);
          }}
          rowData={editRowData}
          onSave={handleSave}
        />
      )}
    </>
  );
}

export default BulkPerRegistration;
